import Permissions from "./permissions";

const accessibleLinks = [
  {
    permission: Permissions.SURVEILLANCE,
    label: "Surveillance",
    icon: "fa-desktop",
    path: "/surveillance",
  },
  {
    permission: Permissions.HISTORIQUE_60J_SURVEILLANCE,
    label: "Historiques Images",
    icon: "fa-images",
    path: "/historique",
  },
  {
    permission: Permissions.CAPTURE_CLAVIER,
    label: "Historiques clavier",
    icon: "fa-keyboard",
    path: "/historique_clavier",
  },
  {
    permission: Permissions.HISTORIQUE_NAVIGATION,
    label: "Historiques Navigation",
    icon: "fa-compass",
    path: "/historique_navigation",
  },
  {
    permission: Permissions.HISTORIQUE_INSTALLATIONS,
    label: "Historiques Installation",
    icon: "fa-download",
    path: "/historique_installation",
  },
  {
    permission: "admin_alert",
    label: "Configurer Alert",
    icon: "fa-cog",
    path: "/configuration_alert",
  },
  {
    permission: "admin_alert",
    label: "Liste Alert",
    icon: "fa-bell",
    path: "/liste_alert",
  },
  {
    permission: "admin_alert",
    label: "Présences",
    icon: "fa-user-check",
    path: "/presences",
  },
];

export default accessibleLinks;
